import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../storeHooks";
import { trackTraceActions } from "redux/Ldb/actions";
import { useParams } from "react-router-dom";
import useInfiniteScroll from "hooks/useInfinteScroll";

const useGetTrackTraceBatchWarehouses = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const [batchWarehouses, setBatchWarehouses] = useState<{ [key: string]: any }>([]);
    const [state, setState] = useState<string>("");
    const [pagination, setPagination] = useState<{ currentPage: string; noOfPages: string }>({
        currentPage: "1",
        noOfPages: "",
    });

    const { updatedLimit, isLoadingMore, setLoadMore } = useInfiniteScroll(
        { current: pagination.currentPage, number_of_pages: pagination.noOfPages },
        10
    );
    const { fetchingBatchWarehouses, fetchBatchWarehousesSuccess, fetchBatchWarehousesFailure } =
        useAppSelector((state) => state.trackTrace);

    const handleStateChange = (value) => {
        setState(value);
    };
    useEffect(() => {
        if (Boolean(fetchBatchWarehousesSuccess)) {
            setBatchWarehouses(fetchBatchWarehousesSuccess?.warehouses);
             setPagination({
                 currentPage: fetchBatchWarehousesSuccess.pagination?.current,
                 noOfPages: fetchBatchWarehousesSuccess.pagination?.number_of_pages,
             });
             setLoadMore(false);
        }
    }, [fetchBatchWarehousesSuccess]);

    useEffect(() => {
        if (id && state) {
            dispatch(trackTraceActions.getBatchWarehouses(state, id, updatedLimit));
        }
    }, [dispatch, id, state, updatedLimit]);

    return {
        data: batchWarehouses,
        isFetching: fetchingBatchWarehouses,
        error: fetchBatchWarehousesFailure,
        handleStateChange,
        state,
        isLoadingMore
    };
};

export default useGetTrackTraceBatchWarehouses;
